import { dateRangeEnum } from '../../constants/dateRangeEnum';
import moment from 'moment';
import { filterNewConst } from '../../constants/documentFilterNew.constantas';

const {
  RESET_FILTER_DOCUMENT,
  APPLY_TYPE_ID,
  APPLY_COMPANY_ID,
  APPLY_TOPIC,
  APPLY_DATE_RANGE,
  APPLY_DATE_RANGE_FIELD,
  APPLY_STATUSES,
  APPLY_SUBTYPES,
  APPLY_SOURCE_DATE_DOCUMENT,
  APPLY_SOURCE_DATE_NUMBER,
  APPLY_EXECUTOR,
  APPLY_RESPONSIBLE_WORKER,
  APPLY_ORGS,
  APPLY_CREATOR,
  APPLY_STREET,
  APPLY_HOUSE,
  APPLY_FLATS,
  SET_FILTER_CHANGE,
  SET_DOCUMENT_FILTER_VALUES,
  APPLY_VIEW_OTHERO_DOCS_SELECTED,
  APPLY_DEADLINE_DATE,
  APPLY_TOPIC_IDS,
  APPLY_ORGS_FILTER,
  APPLY_SOURCE,
} = filterNewConst;

const defaultDateRange = [
  moment().subtract(3, 'month').add(1, 'days'),
  moment(),
];

export const dateRangeOrgs = [moment('01.01.2000', 'DD.MM.YYYY'), moment()];

const defaultFilterValue = {
  dateRange: defaultDateRange,
  dateRangeField: dateRangeEnum.CREATE,
  companyId: undefined,
  typeId: undefined,
  topic: '',
  topicIds: [],
  statuses: [1, 2, 3],
  subtypes: [],
  sourceDate: undefined,
  sourceNumber: '',
  executerId: undefined,
  responsibleWorkerId: undefined,
  orgsIds: [],
  creatorIds: [],
  streetId: undefined,
  houseId: undefined,
  flatIds: [],
  viewOtherDocsSelected: false,
  deadlineDate: undefined,
  sourceId: undefined,
};

const initialState = {
  filterChanged: false,
  ...defaultFilterValue,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case RESET_FILTER_DOCUMENT:
      return initialState;
    case APPLY_TYPE_ID:
      if (!payload) {
        return {
          ...defaultFilterValue,
          dateRange: state.dateRange,
          dateRangeField: state.dateRangeField,
          ...(state.companyId && { companyId: state.companyId }),
          filterChanged: true,
        };
      }

      return {
        ...state,
        typeId: payload,
        subtypes: [],
        filterChanged: true,
      };
    case APPLY_ORGS_FILTER:
      return {
        ...initialState,
        statuses: [],
        dateRange: dateRangeOrgs,
        companyId: payload.companyId || null,
        orgsIds: payload.orgsIds || [],
      };
    case SET_DOCUMENT_FILTER_VALUES:
      return {
        ...initialState,
        ...payload,
      };
    case APPLY_TOPIC_IDS:
      return {
        ...state,
        topicIds: payload,
        filterChanged: true,
      };
    case APPLY_DEADLINE_DATE:
      return {
        ...state,
        deadlineDate: payload,
      };
    case SET_FILTER_CHANGE:
      return {
        ...state,
        filterChanged: payload,
      };
    case APPLY_COMPANY_ID:
      return {
        ...state,
        companyId: payload,
        filterChanged: true,
      };
    case APPLY_TOPIC:
      return {
        ...state,
        topic: payload,
        filterChanged: true,
      };
    case APPLY_DATE_RANGE:
      return {
        ...state,
        dateRange: payload,
        filterChanged: true,
      };
    case APPLY_DATE_RANGE_FIELD:
      return {
        ...state,
        dateRangeField: payload,
        filterChanged: true,
      };
    case APPLY_STATUSES:
      return {
        ...state,
        statuses: payload,
        filterChanged: true,
      };
    case APPLY_SUBTYPES:
      return {
        ...state,
        subtypes: payload,
        filterChanged: true,
      };
    case APPLY_SOURCE_DATE_DOCUMENT:
      return {
        ...state,
        sourceDate: payload,
        filterChanged: true,
      };
    case APPLY_SOURCE_DATE_NUMBER:
      return {
        ...state,
        sourceNumber: payload,
        filterChanged: true,
      };
    case APPLY_EXECUTOR:
      return {
        ...state,
        executerId: payload,
        filterChanged: true,
      };
    case APPLY_RESPONSIBLE_WORKER:
      return {
        ...state,
        responsibleWorkerId: payload,
        filterChanged: true,
      };
    case APPLY_ORGS:
      return {
        ...state,
        orgsIds: payload,
        filterChanged: true,
      };
    case APPLY_CREATOR:
      return {
        ...state,
        creatorIds: payload,
        filterChanged: true,
      };
    case APPLY_STREET:
      return {
        ...state,
        streetId: payload,
        houseId: undefined,
        flatIds: [],
        filterChanged: true,
      };
    case APPLY_HOUSE:
      return {
        ...state,
        houseId: payload,
        flatIds: [],
        filterChanged: true,
      };
    case APPLY_FLATS:
      return {
        ...state,
        flatIds: payload,
        filterChanged: true,
      };
    case APPLY_VIEW_OTHERO_DOCS_SELECTED:
      return {
        ...state,
        viewOtherDocsSelected: payload,
        filterChanged: true,
      };
    case APPLY_SOURCE:
      return {
        ...state,
        sourceId: payload,
        filterChanged: true,
      };
    default:
      return state;
  }
};
